import * as Yup from 'yup';

const MIN_PHONE = 10;
const MAX_PHONE = 10;

export const validatorPhone = (value, translation) => {
	if (!value) {
		return Promise.reject(new Error(translation("accreditation.isRequire")));
	}
	if ((value.length < MIN_PHONE || value.length > MAX_PHONE)) {
		return Promise.reject(new Error(translation("accreditation.phoneError")))
	}
  const validPrefixes = ['03', '05', '07', '08', '09'];
  if (!validPrefixes.some(prefix => value.startsWith(prefix))) {
    return Promise.reject(new Error(translation("accreditation.phoneError")));
  }
  if (!/^[0-9]+$/i.test(value)) {
		return Promise.reject(translation("accreditation.phoneError"));
	}
	if (value === '0'.repeat(value.length)) {
    return Promise.reject(new Error(translation("accreditation.phoneError")));
  }

	return Promise.resolve();
}

export const validatorPhoneAllowEmpty = (value, translation) => {
	if(!value) {
		return Promise.resolve();
	}
	if ((value.length < MIN_PHONE || value.length > MAX_PHONE)) {
		return Promise.reject(new Error(translation("accreditation.phoneError")))
	}
  const validPrefixes = ['03', '05', '07', '08', '09'];
  if (!validPrefixes.some(prefix => value.startsWith(prefix))) {
    return Promise.reject(new Error(translation("accreditation.phoneError")));
  }
  if (!/^[0-9]+$/i.test(value)) {
		return Promise.reject(translation("accreditation.phoneError"));
	}
	if (value === '0'.repeat(value.length)) {
    return Promise.reject(new Error(translation("accreditation.phoneError")));
  }
	return Promise.resolve();
}

export const validatorEmail = (value, translation) => {
  const validationSchema = Yup.string()
    .required(translation('accreditation.isRequire'))
    .email(translation('invalidEmail'));

  return validationSchema.validate(value)
    .catch(error => Promise.reject(error.message));
};

export const validatorEmailAllowEmpty = (value, translation) => {
	if (!value) {
		return Promise.resolve();
	}
	if (!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
		return Promise.reject(new Error(translation("invalidEmail")));
	} 
  const validationSchema = Yup.string()
    .notRequired(translation('accreditation.isRequire'))
    .email(translation('invalidEmail'));

  return validationSchema.validate(value)
    .catch(error => Promise.reject(error.message));
};

const MIN_PASSWORD = 6;
export const validatorPassword = (value, translation , textError) => {
	if(!value) {
		return Promise.reject(translation("isReq"))
	}

	if(value.length < MIN_PASSWORD) {
		return Promise.reject(textError || translation("minPassword"));
	}
	return Promise.resolve();
}

export function isValidCccdQr(qrText) {
	if (typeof qrText !== "string") return false;
	const arr = qrText.split("|");
	if (arr.length !== 7) return false;
  
	// 1. Số CCCD: 12 số, bắt đầu bằng 0-9
	if (!/^\d{12}$/.test(arr[0].trim())) return false;
  
	// 2. Số định danh: 9 số
	if (!/^\d{9}$/.test(arr[1].trim())) return false;
  
	// 3. Họ tên: không rỗng
	if (!arr[2].trim()) return false;
  
	// 4. Ngày sinh: 8 số, định dạng DDMMYYYY
	if (!/^\d{8}$/.test(arr[3].trim())) return false;
  
	// 5. Giới tính: Nam/Nữ (không phân biệt hoa thường)
	const gender = arr[4].trim().toLowerCase();
	if (!["nam", "nữ", "nu"].includes(gender)) return false;
  
	// 6. Địa chỉ: không rỗng
	if (!arr[5].trim()) return false;
  
	// 7. Ngày cấp: 8 số, định dạng DDMMYYYY
	if (!/^\d{8}$/.test(arr[6].trim())) return false;
  
	return true;
  }

  export function validateTaxOrIdentityStrict(input) {
  if (!input || typeof input !== "string") {
    return { isValid: true, value: "" };
  }

  const raw = input.trim();

  // 1) Trường hợp có dấu "-" => ưu tiên coi là MST phụ thuộc (XXXXXXXXXX-XXX)
  if (raw.includes("-")) {
    // Không chấp nhận khoảng trắng - format phải chính xác: XXXXXXXXXX-XXX
    if (!/^\d{10}-\d{3}$/.test(raw)) {
      return {
        isValid: false,
        errorMessage: "Mã số thuế phụ thuộc không hợp lệ (định dạng: XXXXXXXXXX-XXX, không được có khoảng trắng)"
      };
    }

    const clean = raw.replace("-", "");
    return { isValid: true, type: "MST_PHU_THUOC", value: clean };
  }

  // 2) Không có "-" => chỉ cho phép số
  const clean = raw.replace(/\D/g, "");
  if (clean.length === 0) {
    return { isValid: false, errorMessage: "Thông tin chỉ được chứa chữ số (và dấu '-' nếu là MST phụ thuộc), không được có khoảng trắng" };
  }

  // Nếu người dùng nhập ký tự lẫn chữ mà bị strip -> coi là sai
  if (clean.length !== raw.replace(/\s+/g, "").length) {
    return {
      isValid: false,
      errorMessage: "Thông tin chỉ được chứa chữ số (và dấu '-' nếu là MST phụ thuộc), không được có khoảng trắng"
    };
  }

  // 3) Phân loại theo "đầu" + độ dài

  // CCCD: 12 số. Nếu muốn chặt theo "đầu 0" thì bật rule ở dưới.
  if (clean.length === 12) {
    // Rule prefix (tùy chọn): CCCD thường bắt đầu bằng 0
    // Nếu bạn muốn bắt buộc: uncomment dòng dưới
    // if (!clean.startsWith("0")) return { isValid:false, errorMessage:"CCCD không hợp lệ (phải bắt đầu bằng 0)" };

    return { isValid: true, type: "CCCD", value: clean };
  }

  // CMND: 9 số
  if (clean.length === 9) {
    return { isValid: true, type: "CMND", value: clean };
  }

  // MST cá nhân: 10 số
  if (clean.length === 10) {
    return { isValid: true, type: "MST_CA_NHAN", value: clean };
  }

  // Nếu không khớp bất kỳ trường hợp nào
  return {
    isValid: false,
    errorMessage:
      "Thông tin không hợp lệ. Chỉ chấp nhận: CMND (9 số), CCCD (12 số), MST (10 số), hoặc MST phụ thuộc (XXXXXXXXXX-XXX)."
  };
}